import styled from "styled-components";
import {
  PRIMARY_COLOR,
  BOLD_FONT,
  QUERY_IPAD,
  QUERY_IPHONE_6_7_8_PLUS,
} from "@shared/constants";

export const StyledSection = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 150px 32px;

  .content {
    flex: 1;
    max-width: 1000px;
  }

  .cards {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  }

  @media (max-width: ${QUERY_IPAD}px) {
    .cards {
      grid-template-columns: 1fr;
      justify-items: center;
    }
  }

  @media (max-width: ${QUERY_IPHONE_6_7_8_PLUS}px) {
    padding: 100px 24px;
  }
`;

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.04);

  .head {
    height: 116px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .img-placeholder {
      background-color: ${PRIMARY_COLOR};
      height: 100%;
    }

    .blur {
      filter: blur(20px);
      -webkit-filter: blur(20px);
      -moz-filter: blur(20px);
      -o-filter: blur(20px);
      -ms-filter: blur(20px);
      transition: filter 0.3s;

      &:hover {
        filter: blur(0);
      }
    }
  }

  .body {
    flex: 1;
    padding: 32px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 28px;
      font-weight: ${BOLD_FONT};
      font-size: 20px;
    }

    .desc {
      margin-bottom: 40px;
      font-size: 16px;
    }

    .links-container {
      position: relative;
      z-index: 1;
      display: flex;
      justify-content: center;
      margin-bottom: 24px;

      .icon-link {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #ffffff;
        border: 2px solid #f5f5f6;
        border-radius: 50%;
        padding: 8px;
        transition: border-color 0.3s ease;

        &:not(:last-child) {
          margin-right: 8px;
        }

        &:hover {
          border-color: ${PRIMARY_COLOR};
        }
      }

      &::before {
        position: absolute;
        z-index: -1;
        content: "";
        left: 0;
        right: 0;
        height: 2px;
        top: 50%;
        background-color: #f5f5f6;
      }
    }

    .tags {
      font-size: 14px;
      color: #434f6d;
    }
  }

  @media (max-width: ${QUERY_IPAD}px) {
    max-width: 500px;
  }

  @media (max-width: ${QUERY_IPHONE_6_7_8_PLUS}px) {
    .body {
      padding: 20px;

      .title {
        font-size: 20px;
      }
    }
  }
`;
